import { render, staticRenderFns } from "./EditorialPlan.vue?vue&type=template&id=0dd57bb9&"
import script from "./EditorialPlan.vue?vue&type=script&lang=js&"
export * from "./EditorialPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VStepper } from 'vuetify/lib/components/VStepper';
installComponents(component, {VOverlay,VProgressCircular,VStepper})
